import {useQuery, gql} from '@apollo/client'

export const GET_USER_AUDIT_DETAILS = gql`
  query GetUserAuditDetails($fetchType: String!, $page: Int!, $pageSize: Int!) {
    getAuditDetails(fetchType: $fetchType, page: $page, pageSize: $pageSize) {
      page
      pageSize
      totalCount
      users {
        EVENT_TYPE
        EMAIL
        USER_EMAIL
        USERNAME
        USER_ROLE
        LAST_UPDATED_DATE_TIME
        CLIENT_ID
        CLIENT_NAME
        PROJECT_ID
        GROUP_NAME
        ROLE_ID
        GROUP_TYPE_ID
        GROUP_TYPE
        IS_TEMPORARY
        START_DATE
        END_DATE
        ACTION
        ACTION_TIME
        CHANGED_BY
        GROUP_ID_UA
        USER_GROUP
        USER_ROLE_UA
        STATUS
        CHANGED_DATA
        LAST_UPDATED
        PERMISSION
        SNAPSHOT
      }
    }
  }
`

export function useUserAuditDetails({page, pageSize, skip = false}) {
  const {
    data: userAuditDetailsData,
    loading: loadingUserAuditDetails,
    error: errorUserAuditDetails,
    refetch: refetchUserAuditDetails
  } = useQuery(GET_USER_AUDIT_DETAILS, {
    context: {clientName: 'adminPanel'},
    variables: {fetchType: 'user', page, pageSize},
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    skip
  })

  return {userAuditDetailsData, loadingUserAuditDetails, errorUserAuditDetails, refetchUserAuditDetails}
}
